import {gql} from 'apollo-angular';

export const getUserByIdQuery = gql`
  query Query {
    get_user_json {
      id
      name
      email
      instance_id
      jwt_token
      role {
        id
        name
        permissions {
          id
          permission_name
          read
        }
      }
    }
  }
`;
